// SEO de Produto — fonte iSET (tabela products, sincronizada do DB tenant; NÃO usa OMIE).
// KPIs de SEO on-page + cruzamento com GSC (striking distance, top por impressão).
import { useEffect, useState } from "react";
import { api } from "../../api.ts";
import { fmtNum } from "../../lib/format.ts";

interface Payload {
  source: string;
  summary: {
    total: number;
    sem_slug: number;
    sem_title: number;
    sem_meta: number;
    thin_desc: number;
    com_trafego: number;
    striking: number;
    impressions: number;
    clicks: number;
  };
  top_products: Array<{ name: string; url: string; impressions: number; clicks: number; position: number; has_meta: boolean }>;
  sem_seo_sample: Array<{ name: string; url: string; sem_slug: boolean; sem_meta: boolean }>;
}

export function CatalogoPanel({ slug }: { slug: string }) {
  const [data, setData] = useState<Payload | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.get<Payload>(`/api/t/${slug}/tactical/catalogo`).then(setData).catch((e) => setErr(e.message));
  }, [slug]);

  if (err) return <div className="card"><p style={{ color: "var(--red)" }}>erro: {err}</p></div>;
  if (!data) return <div className="center-loading">carregando…</div>;

  const s = data.summary;
  if (s.total === 0) {
    return <div className="card"><p className="eyebrow">SEO de Produto · iSET</p>
      <p>Nenhum produto sincronizado ainda. O ETL da iSET popula a tabela <code>products</code> a partir do catálogo publicado.</p></div>;
  }
  const ctr = s.impressions > 0 ? (s.clicks / s.impressions) * 100 : 0;
  const semSeo = s.sem_slug + s.sem_meta; // aproximação de SEO incompleto

  return (
    <>
      <div className="kpi-grid">
        <div className="kpi-card">
          <div className="label">Produtos iSET</div>
          <div className="value">{fmtNum(s.total)}</div>
          <div className="meta"><span className="mono">{fmtNum(s.com_trafego)} com impressão no Google</span></div>
        </div>
        <div className="kpi-card">
          <div className="label">Impressões / cliques (GSC)</div>
          <div className="value">{fmtNum(s.impressions)}</div>
          <div className="meta"><span className="mono">{fmtNum(s.clicks)} cliques · CTR {ctr.toFixed(2)}%</span></div>
        </div>
        <div className="kpi-card" style={{ borderColor: s.striking > 0 ? "var(--amber)" : "var(--border)" }}>
          <div className="label">Striking distance</div>
          <div className="value">{fmtNum(s.striking)}</div>
          <div className="meta"><span className="mono">pos 4–12, ≥1k impr — empurrar pro topo</span></div>
        </div>
        <div className="kpi-card" style={{ borderColor: s.sem_slug > 0 ? "var(--amber)" : "var(--border)" }}>
          <div className="label">SEO on-page incompleto</div>
          <div className="value">{fmtNum(s.sem_slug)}<small> sem slug</small></div>
          <div className="meta"><span className="mono">{fmtNum(s.sem_meta)} sem meta · {fmtNum(s.thin_desc)} desc. fina</span></div>
        </div>
      </div>

      {data.top_products.length > 0 && (
        <div className="section">
          <div className="section-head">
            <div>
              <p className="eyebrow">Produtos iSET · GSC</p>
              <h2>Top produtos por impressão (oportunidade de CTR)</h2>
            </div>
          </div>
          <div className="card">
            <table className="simple">
              <thead><tr><th>Produto</th><th style={{ textAlign: "right" }}>Impr.</th><th style={{ textAlign: "right" }}>Cliques</th><th style={{ textAlign: "right" }}>Pos.</th><th>Meta</th></tr></thead>
              <tbody>
                {data.top_products.map((p, i) => (
                  <tr key={i}>
                    <td><a href={`https://www.lojanerea.com.br${p.url}`} target="_blank" rel="noreferrer">{p.name}</a></td>
                    <td style={{ textAlign: "right" }} className="mono">{fmtNum(p.impressions)}</td>
                    <td style={{ textAlign: "right" }} className="mono">{fmtNum(p.clicks)}</td>
                    <td style={{ textAlign: "right" }} className="mono" >{p.position}</td>
                    <td>{p.has_meta ? "✓" : <span style={{ color: "var(--amber)" }}>sem meta</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {data.sem_seo_sample.length > 0 && (
        <div className="section">
          <div className="section-head">
            <div>
              <p className="eyebrow">Cleanup SEO</p>
              <h2>Produtos sem slug ou sem meta description (amostra)</h2>
            </div>
          </div>
          <div className="card">
            <table className="simple">
              <thead><tr><th>Produto</th><th>Pendência</th></tr></thead>
              <tbody>
                {data.sem_seo_sample.map((p, i) => (
                  <tr key={i}>
                    <td><a href={`https://www.lojanerea.com.br${p.url}`} target="_blank" rel="noreferrer">{p.name}</a></td>
                    <td className="mono" style={{ fontSize: ".82rem" }}>
                      {[p.sem_slug ? "slug" : null, p.sem_meta ? "meta description" : null].filter(Boolean).join(" + ")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
